const traversalFunctions = [
  null, // index 0 (unused)
  null, // index 1 (single property access doesn't need optimization)
  (obj, path) => obj?.[path[0]]?.[path[1]],
  (obj, path) => obj?.[path[0]]?.[path[1]]?.[path[2]],
  (obj, path) => obj?.[path[0]]?.[path[1]]?.[path[2]]?.[path[3]],
  (obj, path) => obj?.[path[0]]?.[path[1]]?.[path[2]]?.[path[3]]?.[path[4]],
  (obj, path) => obj?.[path[0]]?.[path[1]]?.[path[2]]?.[path[3]]?.[path[4]]?.[path[5]],
  (obj, path) => obj?.[path[0]]?.[path[1]]?.[path[2]]?.[path[3]]?.[path[4]]?.[path[5]]?.[path[6]],
  (obj, path) => obj?.[path[0]]?.[path[1]]?.[path[2]]?.[path[3]]?.[path[4]]?.[path[5]]?.[path[6]]?.[path[7]]
]

function createTraversalFunction(length) {
  const accessors = Array.from({ length }, (_, i) => `?.[path[${i}]]`);
  const expr = "obj" + accessors.join("");
  const fn = new Function("obj", "path", `return ${expr}`);
  traversalFunctions[length] = fn;
  return fn;
}

export function traverse(state, path) {
  const len = path.length;
  if (len === 0) return state;
  if (len === 1) return state[path[0]];
  
  // Use existing function if available
  if (len < traversalFunctions.length && traversalFunctions[len]) {
    return traversalFunctions[len](state, path);
  }
  
  // Create and cache new function if needed
  if (!traversalFunctions[len]) {
    return createTraversalFunction(len)(state, path);
  }
  
  return traversalFunctions[len](state, path);
}

